import React from "react";
import { IProps, QRCode as ReactQRCode } from "react-qrcode-logo";

export interface QrCodeProps extends IProps {
  /**
   * Value of QR Code when scanning
   */
  value: string;
  /**
   * width and height of QR code in pixels
   */
  size?: number;
}

export function QrCode({ value, size = 150, ...otherProps }: QrCodeProps) {
  return (
    <div data-testid="qr-code-component">
      <ReactQRCode value={value} size={size} {...otherProps} />
    </div>
  );
}
